export default {
  Community: {
    editingCase: {
      titleTextareaPlaceholder: "Describa el caso o haga una pregunta",
      sybmolCount: "El número de caracteres debe ser de {min} a {max}",
      wordsCount: "El número de palabras debe ser de {min} a {max}",
      mobiledocPlaceholder:
        "Cuéntenos más sobre los datos del examen del paciente",
      mobiledocLabel: "Datos del examen",
      tags: "Etiquetas",
      editCase: "Editar el caso",
      anamnesisPlaceholder:
        "Cuéntenos más sobre el historial médico del paciente",
      treatmentPlaceholder: "Cuéntanos más sobre el tratamiento del paciente",
      caseNotesPlaceholder: "Cuéntanos más sobre el caso",
      questionNotesPlaceholder: "Cuéntanos más sobre la pregunta",
      addImage: "Adjuntar una imagen",
      anamnesis: "Anamnesis",
      treatment: "Tratamiento",
      notes: "Adición",
    },
    uploader: {
      case: {
        title: "Añadir un caso",
        description: "Comparta casos interesantes de su práctica",
      },
      question: {
        title: "Haga una pregunta",
        description:
          'Los usuarios responderán más rápido si seleccionas"Pregunta".',
      },
    },
    title: "Comunidad",
    description:
      "Intercambio de conocimientos entre médicos sobre casos clínicos",
    all_cases: "Todos los casos",
    my_cases: "Mis casos",
    case: {
      shareLink: {
        1: "Mira el caso",
        2: "en la Plataforma “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
    noCasesLang: {
      1: "Aún no hay casos publicados en este idioma",
      2: "¡Sé el primero en compartir un estudio DICOM y obtén opiniones de colegas!",
    },
    filter: {
      status: {
        placeholder: "Ordenar casos",
        values: {
          popular: "Populares primero",
          actual: "Recientes primero",
        },
        options: {
          base: "Mostrar primero",
          popular: "Populares",
          actual: "Recientes",
        },
      },
      modality: {
        placeholder: "Modalidad",
      },
      bodypart: {
        placeholder: "Área de estudio",
      },
      sex: {
        placeholder: "Sexo",
        values: {
          M: "Masculino",
          F: "Femenino",
        },
      },
    },
  },
  h1_community: "Comunidad Médica",
};
